import { Info } from 'lucide-react';
import { parseSlideBody } from '../../../lib/slideMarkup';
import { LinkifiedText } from '../../ui/LinkifiedText';

/**
 * Renders a slide body's markup blocks (headings, lists, callouts,
 * paragraphs). Inline content goes through LinkifiedText per line, so
 * everything stays text nodes — no raw HTML ever reaches the DOM.
 */
export function SlideRichText({ body }: { body: string }) {
  const blocks = parseSlideBody(body);
  return (
    <div className="space-y-3">
      {blocks.map((block, i) => {
        switch (block.type) {
          case 'heading':
            return (
              <h3 key={i} className="pt-1 text-base font-semibold text-fg">
                <LinkifiedText text={block.text} />
              </h3>
            );
          case 'bullets':
            return (
              <ul key={i} className="list-disc space-y-1.5 pl-6 text-sm leading-relaxed text-fg">
                {block.items.map((item, j) => (
                  <li key={j}>
                    <LinkifiedText text={item} />
                  </li>
                ))}
              </ul>
            );
          case 'numbered':
            return (
              <ol key={i} className="list-decimal space-y-1.5 pl-6 text-sm leading-relaxed text-fg">
                {block.items.map((item, j) => (
                  <li key={j}>
                    <LinkifiedText text={item} />
                  </li>
                ))}
              </ol>
            );
          case 'callout':
            return (
              <div
                key={i}
                className="flex items-start gap-2 rounded-token-sm bg-info-soft/15 px-3 py-2.5 text-sm leading-relaxed text-info-soft-fg"
              >
                <Info aria-hidden className="mt-0.5 h-4 w-4 shrink-0" />
                <span>
                  <LinkifiedText text={block.text} />
                </span>
              </div>
            );
          case 'paragraph':
            return (
              <p key={i} className="text-sm leading-relaxed text-fg">
                <LinkifiedText text={block.text} />
              </p>
            );
        }
      })}
    </div>
  );
}
